module.exports = __webpack_public_path__ + "static/7.31d4edf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/china/7.jpg
// module id = 844
// module chunks = 165889800748998